import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, of, switchMap, throwError } from 'rxjs';
import { IAppConfig } from '../shared/interfaces/app-config';
import { StaffInfo } from '../shared/interfaces/staff-info';
import { AppConfigService } from './app-config.service';

@Injectable({
  providedIn: 'root',
})
export class StaffSearchService {
  config: IAppConfig;

  constructor(
    readonly http: HttpClient,
    private appConfigService: AppConfigService
  ) {
    this.config = this.appConfigService.getConfig();
  }

  getStaffDataByDBN(dbn: string): Observable<StaffInfo[]> {
    return this.http
      .get<StaffInfo[]>(`${this.config.studentApiUrl}/Staff/Search/${dbn}`)
      .pipe(catchError(this.handleError));
  }

  getStaffDataByTitle(dbn: string, title: string): Observable<StaffInfo[]> {
    return this.http
      .get<StaffInfo[]>(
        `${this.config.studentApiUrl}/Staff/SearchByTitle/${dbn}/${title}`
      )
      .pipe(catchError(this.handleError));
  }

  getStaffData(staffObj: object): Observable<StaffInfo[]> {
    return this.http
      .post<StaffInfo[]>(
        `${this.config.studentApiUrl}/Staff/SearchStaff`,
        staffObj
      )
      .pipe(catchError(this.handleError));
  }

  getAllStaffForSchool(
    dbn: string,
    district?: number
  ): Observable<StaffInfo[]> {
    // First API call to get staff by DBN
    return this.http
      .get<StaffInfo[]>(`${this.config.studentApiUrl}/Staff/Search/${dbn}`)
      .pipe(
        catchError(() => {
          return of([]); // Return an empty array on error
        }),
        // If the first API returns an empty array, switch to the second API call by district
        switchMap((staffByDbn) => {
          if (staffByDbn.length === 0 && district !== null) {
            return this.http
              .get<StaffInfo[]>(
                `${this.config.studentApiUrl}/Staff/SearchByDistrict/${district}`
              )
              .pipe(
                catchError(() => {
                  return of([]); // Return an empty array on error
                })
              );
          } else {
            // If the first API has data, return it and don't call the second API
            return of(staffByDbn);
          }
        })
      );
  }

  // Error handling
  handleError(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    //window.alert(errorMessage);
    return throwError(() => {
      return errorMessage;
    });
  }
}
